import { render, staticRenderFns } from "./Export2.vue?vue&type=template&id=c6561f56&"
import script from "./Export2.vue?vue&type=script&lang=js&"
export * from "./Export2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports